import React from 'react';

const Unknown = () => {
  return (
    <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="34" height="24" rx="4" fill="white" />
      <rect
        x="0.25"
        y="0.25"
        width="33.5"
        height="23.5"
        rx="3.75"
        stroke="black"
        strokeOpacity="0.15"
        strokeWidth="0.5"
      />
      <rect y="5" width="34" height="4" fill="#C1C3C6" />
      <rect x="3" y="15" width="6" height="3" rx="1.5" fill="#C1C3C6" />
      <rect x="11" y="15" width="3" height="3" rx="1.5" fill="#C1C3C6" />
    </svg>
  );
};

export default Unknown;
